/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { GridRow } from "../../QuoteView.styled";
import QuoteStatus from "../../../QuoteList/components/QuoteStatus";
import QuoteAction from "../../../QuoteList/components/QuoteAction";
import quoteErrorIcon from "@icons/quite-error-ic.svg";
import { quoteLostHesusReasons } from "@utils/constants";
import UserInfo from "@utils/UserInfo";
import {
  BreadCrumb,
  ProductTitle,
  QuoteReason,
  GridRowReason,
} from "./Header.styled";
import "../../QuoteView.scss";

const Header = (props) => {
  const {
    t,
    quoteData,
    statusId,
    setRefreshState,
    setIsRefeshSiteData,
    jobsiteNeedKickoff,
  } = props;

  const history = useNavigate();
  const [countryId, setCountryId] = useState(UserInfo.countryId());
  const [quoteReasons, setQuoteReasons] = useState([]);

  useEffect(() => {
    if ([6, 7].includes(parseInt(statusId, 10)) && countryId !== undefined) {
      const quoteReasonData = quoteLostHesusReasons[statusId][countryId].find(
        (quoteType) =>
          parseInt(quoteType.value, 10) === parseInt(quoteData?.reasonLost, 10)
      );
      setQuoteReasons(quoteReasonData);
    }
  }, [statusId, countryId]);

  return (
    <>
      <GridRow column="1fr" marginBottom="0px">
        <BreadCrumb>
          <Link
            className="quote_view__link"
            to={`/site/view/${quoteData.site.id}/quotes`}
          >
            {"<"}
            {t("GENERAL_BACK_TO_LIST")}
          </Link>
        </BreadCrumb>
      </GridRow>
      <GridRow column="1fr auto auto" gridGap="0.25rem">
        <div>
          <ProductTitle>
            # {quoteData.id + " - " + t(quoteData?.name)}
          </ProductTitle>
        </div>

        <QuoteStatus status={quoteData?.status} statusOpacity="1" />
        <QuoteAction
          quoteId={quoteData.id}
          siteId={quoteData.site.id}
          status={quoteData.status}
          isActive={quoteData.isActive}
          onRefreshData={setRefreshState}
          setIsRefeshSiteData={setIsRefeshSiteData}
          countryId={countryId}
          pageType="view"
          jobsiteNeedKickoff={jobsiteNeedKickoff}
        />
      </GridRow>
      {(parseInt(quoteData.status, 10) === 6 ||
        parseInt(quoteData.status, 10) === 7) && (
        <GridRowReason column="auto 96%">
          <Image
            src={quoteErrorIcon}
            className="quote_view__header-image-icon"
          />
          <div>
            <QuoteReason fontWeight="700" fontSize="14px">
              {t("QUOTE_LOST_TITLE")}
            </QuoteReason>
            <QuoteReason>{t(quoteReasons?.label)}</QuoteReason>
          </div>
        </GridRowReason>
      )}
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
